import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import Header from "../components/Header";

function PartyBuses() {
  return (
    <>
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('service7.jpeg')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            Party Buses
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>-</span>
            <span className="text-logo-green">Party Buses</span>
          </div>
        </div>
      </div>
    </section>

        {/* Explore Our Luxury Fleet Section */}
      <section className="py-16 px-4 md:px-6 lg:px-10 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-6xl mx-auto">
          {/* Main Heading */}
          <h1 className="text-center font-bold text-gray-900 mb-16">
            EXPLORE OUR LUXURY FLEET
          </h1>

          {/* Luxury Sedans */}
          <div className="mb-20">
            <h2 className="font-bold text-gray-800 mb-8 pb-4 border-b-2 border-gray-200">
              Luxury Sedans
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              {/* Text Content */}
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Ideal for:</span> Business travel, airport transfers, executive commutes
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Capacity:</span> Up to 3 passengers
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Features:</span> Plush leather seats, climate control, Wi-Fi, professional chauffeur
                  </p>
                </div>
              </div>
              
              {/* Image */}
              <div className="rounded-xl overflow-hidden shadow-2xl h-[400px]">
                <img 
                  src="fleet6.png"
                  alt="Luxury Sedan"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Stretch Limousines */}
          <div className="mb-20">
            <h2 className="font-bold text-gray-800 mb-8 pb-4 border-b-2 border-gray-200">
              Stretch Limousines
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              {/* Image */}
              <div className="rounded-xl overflow-hidden shadow-2xl h-[400px] lg:order-1">
                <img 
                  src="blog13.png"
                  alt="Stretch Limousine"
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Text Content */}
              <div className="space-y-6 lg:order-2">
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Ideal for:</span> Weddings, proms, nights out, VIP events
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Capacity:</span> 6-10 passengers
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Features:</span> Mood lighting, premium sound system, minibar, spacious seating
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* SUV Limousines */}
          <div className="mb-20">
            <h2 className="font-bold text-gray-800 mb-8 pb-4 border-b-2 border-gray-200">
              SUV Limousines (Escalade, Suburban)
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              {/* Text Content */}
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Ideal for:</span> Group travel, corporate teams, luxury family trips
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Capacity:</span> 6-8 passengers
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Features:</span> Spacious interior, luxury amenities, privacy partition, entertainment system
                  </p>
                </div>
              </div>
              
              {/* Image */}
              <div className="rounded-xl overflow-hidden shadow-2xl h-[400px]">
                <img 
                  src="blog12.png"
                  alt="SUV Limousine"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Sprinter Vans & Executive Vans */}
          <div className="mb-20">
            <h2 className="font-bold text-gray-800 mb-8 pb-4 border-b-2 border-gray-200">
              Sprinter Vans & Executive Vans
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              {/* Image */}
              <div className="rounded-xl overflow-hidden shadow-2xl h-[400px] lg:order-1">
                <img 
                  src="blog14.jpg"
                  alt="Sprinter Van"
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Text Content */}
              <div className="space-y-6 lg:order-2">
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Ideal for:</span> Large groups, corporate shuttles, wedding parties
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Capacity:</span> 10-14 passengers
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Features:</span> Comfortable seating, luggage space, climate control
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Coach Buses */}
          <div className="mb-20">
            <h2 className="font-bold text-gray-800 mb-8 pb-4 border-b-2 border-gray-200">
              Coach Buses
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              {/* Text Content */}
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Ideal for:</span> Corporate events, weddings, large group transfers
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Capacity:</span> 20-50+ passengers
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="mr-4 mt-1">
                    <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-900">
                    <span className="font-semibold">Features:</span> Restroom facilities, reclining seats, entertainment systems
                  </p>
                </div>
              </div>
              
              {/* Image */}
              <div className="rounded-xl overflow-hidden shadow-2xl h-[400px]">
                <img 
                  src="fleet1.webp"
                  alt="Coach Bus"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gray-900 py-12 px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl font-bold text-white mb-6">
            Ready to Book Your Party Bus?
          </h2>
          <p className="text-gray-300 text-lg mb-8">
            Experience luxury and fun with our professional party bus services
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/booknow"
              className="bg-black text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-800 transition-colors"
            >
              BOOK NOW
            </a>
            <a 
              href="tel:+17182004140"
              className="bg-white text-black px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
            >
              CALL NOW
            </a>
          </div>
        </div>
      </section>
    
    <FAQ/>

    <Footer/>
    </>
  );
}

export default PartyBuses;







